import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { Document, Page, pdfjs } from "react-pdf";
import "./epaper.css";

// ✅ FIXED worker (stable version)
pdfjs.GlobalWorkerOptions.workerSrc =
    "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

const EPaper = () => {
    const [papers, setPapers] = useState([]);
    const [selectedPaper, setSelectedPaper] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [numPages, setNumPages] = useState(null);
    const [scale, setScale] = useState(1);

    // 🔥 FETCH FROM BACKEND
    useEffect(() => {
        fetch("http://localhost:8000/api/epaper")
            .then((res) => res.json())
            .then((data) => {
                setPapers(data);
                if (data.length > 0) {
                    setSelectedPaper(data[0]); // latest
                }
            })
            .catch((err) => console.error("API Error:", err));
    }, []);

    // PDF LOAD SUCCESS
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setPageNumber(1);
    };

    // ZOOM CTRL + SCROLL
    const handleWheel = (e) => {
        if (e.ctrlKey) {
            e.preventDefault();
            setScale((prev) =>
                e.deltaY < 0
                    ? Math.min(prev + 0.1, 3)
                    : Math.max(prev - 0.1, 0.5)
            );
        }
    };

    if (!selectedPaper) {
        return <p style={{ textAlign: "center" }}>Loading E-paper...</p>;
    }

    return (
        <Container fluid className="epaper-wrapper">

            {/* 📰 HEADER */}
            <div className="epaper-header">
                <h2>🗞 ePaper Archive</h2>

                {/* 📅 DATE SELECT */}
                <Form.Select
                    className="date-select"
                    value={selectedPaper.date}
                    onChange={(e) =>
                        setSelectedPaper(
                            papers.find((p) => p.date === e.target.value)
                        )
                    }
                >
                    {papers.map((p) => (
                        <option key={p.date} value={p.date}>
                            {p.date}
                        </option>
                    ))}
                </Form.Select>
            </div>

            <Row>

                {/* 🧭 THUMBNAILS */}
                <Col md={2} className="thumbnail-panel">
                    <Document file={`http://localhost:8000${selectedPaper.file}`}>
                        {numPages &&
                            Array.from(new Array(numPages), (el, index) => (
                                <div
                                    key={index}
                                    className={`thumb ${pageNumber === index + 1 ? "active" : ""
                                        }`}
                                    onClick={() => setPageNumber(index + 1)}
                                >
                                    <Page pageNumber={index + 1} width={90} />
                                </div>
                            ))}
                    </Document>
                </Col>

                {/* 📄 MAIN VIEWER */}
                <Col md={8} className="viewer-panel" onWheel={handleWheel}>
                    <Document
                        file={`http://localhost:8000${selectedPaper.file}`}
                        onLoadSuccess={onDocumentLoadSuccess}
                        loading="Loading PDF..."
                    >
                        <Page pageNumber={pageNumber} scale={scale} />
                    </Document>

                    {/* 🔄 CONTROLS */}
                    <div className="controls">
                        <Button
                            onClick={() => setPageNumber((p) => p - 1)}
                            disabled={pageNumber <= 1}
                        >
                            ⬅ Prev
                        </Button>

                        <span>
                            Page {pageNumber} / {numPages}
                        </span>

                        <Button
                            onClick={() => setPageNumber((p) => p + 1)}
                            disabled={pageNumber >= numPages}
                        >
                            Next ➡
                        </Button>
                    </div>
                </Col>

                {/* 📥 DOWNLOAD */}
                <Col md={2} className="download-panel">
                    <a
                        href={`http://localhost:8000${selectedPaper.file}`}
                        download
                        className="download-btn"
                    >
                        📥 Download PDF
                    </a>
                </Col>

            </Row>
        </Container>
    );
};

export default EPaper;